import { AxiosResponse } from 'axios';
import { CapacityItem } from '../utils/capacity';
import api from '../apis/capacity.api';

export type QueryCapacityRequestOptions = {
	item: CapacityItem;
};

export type QueryCapacityResponseBody =
	| { available?: never; inUse: number; total?: never; unlimited: true }
	| {
			available: number;
			inUse: number;
			total: number;
			unlimited?: false | undefined;
	  };

export async function queryCapacityRequest(
	options: QueryCapacityRequestOptions,
	signal?: AbortSignal,
): Promise<AxiosResponse<QueryCapacityResponseBody>> {
	return await api.get<QueryCapacityResponseBody>(
		`/v1/web/capacity/${options.item}`,
		{ signal },
	);
}

export type UseCapacityRequestOptions = {
	item: CapacityItem;
	quantity: number;
};

export type UseCapacityResponseBody =
	| {
			usedQuantity: number;
			inUse: number;
			available?: never;
			unlimited: true;
	  }
	| {
			usedQuantity: number;
			inUse: number;
			available: number;
			unlimited?: false | undefined;
	  };

export async function useCapacityRequest(
	options: UseCapacityRequestOptions,
	signal?: AbortSignal,
): Promise<AxiosResponse<UseCapacityResponseBody>> {
	return await api.post<UseCapacityResponseBody>(
		`/v1/web/capacity/${options.item}/use`,
		{ quantity: options.quantity },
		{ signal },
	);
}

export type ReturnCapacityRequestOptions = {
	item: CapacityItem;
	quantity: number;
};

export type ReturnCapacityResponseBody =
	| {
			returnedQuantity: number;
			inUse: number;
			available?: never;
			unlimited: true;
	  }
	| {
			returnedQuantity: number;
			inUse: number;
			available: number;
			unlimited?: false | undefined;
	  };

export async function returnCapacityRequest(
	options: ReturnCapacityRequestOptions,
	signal?: AbortSignal,
): Promise<AxiosResponse<ReturnCapacityResponseBody>> {
	return await api.post<ReturnCapacityResponseBody>(
		`/v1/web/capacity/${options.item}/return`,
		{ quantity: options.quantity },
		{ signal },
	);
}
